function vacinas(){
	return {
		"games":[
			{
				"informs":[
					{
						"text":"Quando a defesa natural do corpo não consegue eliminar um agente patogênico, como o vírus SARS-CoV-2, ele causará uma infecção que acarretará os sintomas da doença, COVID-19.",
						"title":"Vacinas: o que são e para que servem?",
						"image":"images/games/informs/vacinas/1.png",
                    },
					{
						"text":"Ainda não foram descobertos remédios para COVID-19, o controle da pandemia poderá ser alcançado pela vacinação da população.",
						"title":"Vacinas: o que são e para que servem?",
						"image":"images/games/informs/vacinas/1.png",
                    },
					{
						"text":"As vacinas têm a função de desencadear uma resposta do sistema imunológico,  simulando uma infecção sem desenvolver a doença.",
						"title":"Vacinas: o que são e para que servem?",
						"image":"images/games/informs/vacinas/1.png",
                    },
					{
						"text":"Existem vários tipos de vacinas, as compostas por vírus atenuados, mortos ou componentes isolados dos mesmos, denominados antígenos (substâncias estranhas ao organismo).",
						"title":"Vacinas: o que são e para que servem?",
						"image":"images/games/informs/vacinas/1.png",
                    },
					{
						"text":"Ao receber uma vacina, o sistema de defesa começa a reconhecer as substâncias que a compõem, estranhas ao corpo, estimulando uma resposta das células de defesa.",
						"title":"Vacinas: o que são e para que servem?",
						"image":"images/games/informs/vacinas/1.png",
                    },
					{
						"text":"Células do sistema imunológico, particularmente os linfócitos, responderão à infecção simulada, produzindo as chamadas “células de memória”.",
						"title":"Vacinas: o que são e para que servem?",
						"image":"images/games/informs/vacinas/1.png",
                    },
					{
						"text":"Dessa forma, se formos infectados com o SARS-CoV-2, já teremos as “células de memória” que irão rapidamente produzir anticorpos contra ele e eliminá-lo.",
						"title":"Vacinas: o que são e para que servem?",
						"image":"images/games/informs/vacinas/1.png",
                    },
					{
						"text":"As vacinas, algumas já disponíveis e outras em fase final de testes, inicialmente não conseguirão combater a pandemia, por isso as medidas de prevenção devem ser mantidas.",
						"title":"Vacinas: o que são e para que servem?",
						"image":"images/games/informs/vacinas/1.png",
                    }
					
				],
				"pathImageGame":"midias/images/games/puzzles/vacinas/1.png"
			}
		]
	};
}

export {vacinas};
